
// src/connects/division-settings-page.js
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import context from '../helpers/context'
import componentId from '../helpers/component-id'
import combineHOC from '../helpers/combine-hoc'
import { trackPage, trackHandlers } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'
import i18next from '../i18n'
import find from 'lodash/find'
import map from 'lodash/map'

//state is an object init from reducer
export const mapStateToProps = (state, ownProps)=> {
  const division = ownProps.division && getArray('division_id', state.divisions.items, state.divisions.currentId) || {}

  return {
    isPhone: state.media.isPhone,
    division: division,
    groups: state.groups.items,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willUpdate: (props, nextProps)=> {
    },
    willMount: (props)=> {
    },
    willUnmount: ()=> {
    },

    addDivisionGroups: (props, groups)=> {
      var groupNames = map(groups, (group)=> {
        dispatch(actions.updateDivisionGroup(props.division.division_id, group.group_id, 'add'))
        return group.name
      }).join(', ')
      dispatch(emitAlertMessage({ message: 'label:added_group', name: groupNames }, 'success'))
    },

    updateDivisionGroup: (props, group, membership)=> {
      if (membership == 'remove')
        dispatch(emitAlertMessage({ message: 'label:group_removed_from_division', name: group.name }, 'success'))
      dispatch(actions.updateDivisionGroup(props.division.division_id, group.group_id, membership))
    },
  }
}


export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var uploadFile
  if (stateProps._uploadFile) {
    uploadFile = find(stateProps._uploadFile, (value, key)=> value)
  }

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps
  }
}

export default combineHOC(
  componentId,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({
    state: {
      active: false,
    },
    exports: true,
  }),
  lifecycle,
  translate(),
  context({ showGroupSelectionDialog: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/division-groups-manager-panel.js